export default "__VITE_ASSET__DkueS_Qj__"